import React, { useEffect, useState } from "react";
import {
  VStack,
  HStack,
  Input,
  Text,
  Box,
  Pressable,
  Divider,
  Image,
  IconButton,
  CloseIcon,
} from "native-base";
import { Dimensions } from "react-native";
import { SearchIcon } from "../../assets/icons/icon-assets";
import { Person } from "../../AVCore/AVCore";
import Moment from "moment";
import AVBody from "../../components/common/AVBody";
import { useSelector, RootStateOrAny, useDispatch } from "react-redux";
import { Loc } from "../../App/Loc";
import Filter from "../../components/common/AVFilter";
import { OrgCardLoader } from "../../components/loaders";
import RenderEvents from "../Events/RenderEvents";
import Dropdown from "../../assets/images/dropdown.svg";
import _ from "lodash";

const MyTeams = () => {
  const user = useSelector((state: RootStateOrAny) => state?.user?.user[0]);
  const followersdatalist = user?.follows;
  const [showCreateNewPage, setShowCreateNewPage] = useState<any>(false);
  const [createType, setCreateType] = useState<any>("");
  const [showEdit, setIsShowEdit] = useState(false);
  const [isOpenConvo, setIsOpenConvo] = useState(false);
  const [isConvoData, setIsConvoData] = useState("");

  useEffect(() => {}, [user?.orgs]);

  return (
    <AVBody
      isGeneral={undefined}
      setIsShowEdit={setIsShowEdit}
      setIsGeneral={undefined}
      isRole={undefined}
      setIsRole={undefined}
      Entity={undefined}
      setIsEntity={undefined}
      type={undefined}
      isHomepage={undefined}
      setShowCreateNewPage={setShowCreateNewPage}
      showCreateNewPage={showCreateNewPage}
      setCreateType={setCreateType}
      createType={createType}
      passEntity={undefined}
      setPassEntity={undefined}
      isOpenConvo={isOpenConvo}
      setIsOpenConvo={setIsOpenConvo}
      setIsConvoData={setIsConvoData}
      isConvoData={isConvoData}
      setIshuddleData={undefined}
    >
      <TeamsContent user={user} followersdatalist={followersdatalist} />
    </AVBody>
  );
};

const TeamsContent = ({ user, followersdatalist }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [teamType, SetTeamType] = useState(Loc.currentLang.menu.all);
  const [data, setTeamsData] = React.useState<any>([]);
  const [teamsList, setTeamsList] = React.useState<any>();
  const dimensions = Dimensions.get("window");
  const isMobile = dimensions?.width <= 500 || false;
  const [searchedValue, setSearchedValue] = useState<any>("");
  const [isDropDown, setIsDropDown] = React.useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [userName, setUserName] = useState("");

  useEffect(() => {
    let mounted = true;

    Person.getSelf()
      .then((user) => {
        if (mounted && user?.name) {
          setUserName(user.name);
        }
      })
      .catch(console.error);

    return () => {
      mounted = false;
    };
  }, []);

  //Dropdown Filter Function
  const setAll = () => {
    setSearchInput("");
    SetTeamType(Loc.currentLang.menu.all);
    const filteredOrgs = user?.orgs?.filter(
      (x) => x?.type !== "Person" && x?.type !== "Channel",
    );
    // Reverse the order of filtered organizations
    const reversedFilteredOrgs = filteredOrgs?.reverse();

    // Combine reversed filtered organizations with followersdatalist
    let finaldata = [...reversedFilteredOrgs, ...(followersdatalist || [])];
    finaldata = _.uniqBy(finaldata, "id");
    finaldata = finaldata
      .filter((org) => org.title)
      .sort((a, b) => a.title.localeCompare(b.title));
    setTeamsData(finaldata);
    setTeamsList(finaldata);
    setIsLoading(false);
  };

  const setMyTeams = () => {
    setSearchInput("");
    SetTeamType(Loc.currentLang.menu.filterTeams);

    const filteredTeams =
      user?.orgs?.filter(
        (x) =>
          (x.type === "PlayerOrg" || x.type === "Team") &&
          x?.status !== "Deleted" &&
          x?.subType === undefined,
      ) || [];
    let reversedTeams = filteredTeams?.reverse();
    reversedTeams = reversedTeams?.filter((x) => x?.type !== "Channel");
    reversedTeams = reversedTeams
      .filter((org) => org.title)
      .sort((a, b) => a.title.localeCompare(b.title));
    setTeamsData(reversedTeams);
    setTeamsList(reversedTeams);
    setIsLoading(false);
  };

  const setLeagues = () => {
    setSearchInput("");
    SetTeamType("Leagues");

    const filteredTeams =
      user?.orgs?.filter(
        (x) =>
          (x.type === "LeagueOwner" ||
            x.type === "LeagueSeason" ||
            x.type === "LeagueGroup") &&
          x?.status !== "Deleted" &&
          x?.subType === undefined,
      ) || [];
    let reversedTeams = filteredTeams?.reverse();
    reversedTeams = reversedTeams?.filter((x) => x?.type !== "Channel");
    reversedTeams = reversedTeams
      .filter((org) => org.title)
      .sort((a, b) => a.title.localeCompare(b.title));
    setTeamsData(reversedTeams);
    setTeamsList(reversedTeams);
    setIsLoading(false);
  };

  const setClub = () => {
    setSearchInput("");
    SetTeamType(Loc.currentLang.menu.clubs);
    const filteredClubs =
      user?.orgs?.filter(
        (x) =>
          (x.subType === "Club" || x.subType === "Term") &&
          x?.status !== "Deleted",
      ) || [];
    let reversedFilteredClubs = filteredClubs?.reverse();
    reversedFilteredClubs = reversedFilteredClubs?.filter(
      (x) => x?.type !== "Channel",
    );
    reversedFilteredClubs = reversedFilteredClubs
      .filter((org) => org.title)
      .sort((a, b) => a.title.localeCompare(b.title));
    setTeamsData(reversedFilteredClubs);
    setTeamsList(reversedFilteredClubs);
    setIsLoading(false);
  };

  const setElite = () => {
    setSearchInput("");
    SetTeamType(Loc.currentLang.menu.eliteClubs);
    const filteredEliteClubs =
      user?.orgs?.filter(
        (x) => x?.type === "Club" && x?.status !== "Deleted",
      ) || [];
    let reversedEliteClubs = filteredEliteClubs?.reverse();
    reversedEliteClubs = reversedEliteClubs?.filter(
      (x) => x?.type !== "Channel",
    );
    reversedEliteClubs = reversedEliteClubs
      .filter((org) => org.title)
      .sort((a, b) => a.title.localeCompare(b.title));
    setTeamsData(reversedEliteClubs);
    setTeamsList(reversedEliteClubs);
    setIsLoading(false);
  };

  const setSchools = () => {
    setSearchInput("");
    SetTeamType(Loc.currentLang.menu.schools);
    const filteredSchools =
      user?.orgs?.filter(
        (x) =>
          (x.type === "School" ||
            x.subType === "Alumni" ||
            x.type === "SchoolYear") &&
          x?.status !== "Deleted",
      ) || [];
    let reversedSchools = filteredSchools?.reverse();
    reversedSchools = reversedSchools?.filter((x) => x?.type !== "Channel");
    reversedSchools = reversedSchools
      .filter((org) => org.title)
      .sort((a, b) => a.title.localeCompare(b.title));
    setTeamsData(reversedSchools);
    setTeamsList(reversedSchools);
    setIsLoading(false);
  };

  const setGroup = () => {
    setSearchInput("");
    SetTeamType(Loc.currentLang.menu.groups);
    const filteredGroups =
      user?.orgs?.filter(
        (x) =>
          x.type === "Group" &&
          (x?.subType === undefined || x?.subType === "Department") &&
          x?.status !== "Deleted",
      ) || [];
    let reversedGroups = filteredGroups?.reverse();
    reversedGroups = reversedGroups?.filter((x) => x?.type !== "Channel");
    reversedGroups = reversedGroups
      .filter((org) => org.title)
      .sort((a, b) => a.title.localeCompare(b.title));
    setTeamsData(reversedGroups);
    setTeamsList(reversedGroups);
    setIsDropDown(false);
    setIsLoading(false);
  };

  const setClass = () => {
    setSearchInput("");
    SetTeamType(Loc.currentLang.menu.classes);
    const filteredClasses =
      user?.orgs?.filter(
        (x) =>
          x?.type === "PlayerOrg" &&
          x?.subType === "Class" &&
          x?.status !== "Deleted",
      ) || [];
    let reversedClasses = filteredClasses?.reverse();
    reversedClasses = reversedClasses?.filter((x) => x?.type !== "Channel");
    reversedClasses = reversedClasses
      .filter((org) => org.title)
      .sort((a, b) => a.title.localeCompare(b.title));
    setTeamsData(reversedClasses);
    setTeamsList(reversedClasses);
    setIsDropDown(false);
    setIsLoading(false);
  };

  const setCommunity = () => {
    setSearchInput("");
    SetTeamType(Loc.currentLang.menu.community);
    const filteredCommunity =
      user?.orgs?.filter(
        (x) => x.type === "Community" && x?.status !== "Deleted",
      ) || [];
    let reversedCommunity = filteredCommunity?.reverse();
    reversedCommunity = reversedCommunity?.filter((x) => x?.type !== "Channel");
    reversedCommunity = reversedCommunity
      .filter((org) => org.title)
      .sort((a, b) => a.title.localeCompare(b.title));
    setTeamsData(reversedCommunity);
    setTeamsList(reversedCommunity);
    setIsDropDown(false);
    setIsLoading(false);
  };

  const setGradClass = () => {
    setSearchInput("");
    SetTeamType(Loc.currentLang.menu.gradClass);
    const filteredGradClasses =
      user?.orgs?.filter(
        (x) =>
          x?.type === "PlayerOrg" &&
          x?.subType === "GradClass" &&
          x?.status !== "Deleted",
      ) || [];
    let reversedGradClasses = filteredGradClasses?.reverse();
    reversedGradClasses = reversedGradClasses?.filter(
      (x) => x?.type !== "Channel",
    );
    reversedGradClasses = reversedGradClasses
      .filter((org) => org.title)
      .sort((a, b) => a.title.localeCompare(b.title));
    setTeamsData(reversedGradClasses);
    setTeamsList(reversedGradClasses);
    setIsDropDown(false);
  };

  const setNeighbors = () => {
    setSearchInput("");
    SetTeamType(Loc.currentLang.menu.neighborHood);
    const filteredNeighborhoods =
      user?.orgs?.filter(
        (x) => x.type === "Neighborhood" && x?.status !== "Deleted",
      ) || [];
    let reversedNeighborhoods = filteredNeighborhoods?.reverse();
    reversedNeighborhoods = reversedNeighborhoods?.filter(
      (x) => x?.type !== "Channel",
    );
    reversedNeighborhoods = reversedNeighborhoods
      .filter((org) => org.title)
      .sort((a, b) => a.title.localeCompare(b.title));
    setTeamsData(reversedNeighborhoods);
    setTeamsList(reversedNeighborhoods);
    setIsDropDown(false);
    setIsLoading(false);
  };

  const setOrgs = () => {
    setSearchInput("");
    SetTeamType(Loc.currentLang.menu.orgs);
    const filteredOrgs =
      user?.orgs?.filter(
        (x) => x.type === "Organization" && x?.status !== "Deleted",
      ) || [];
    let reversedOrgs = filteredOrgs?.reverse();
    reversedOrgs = reversedOrgs?.filter((x) => x?.type !== "Channel");
    reversedOrgs = reversedOrgs
      .filter((org) => org.title)
      .sort((a, b) => a.title.localeCompare(b.title));
    setTeamsData(reversedOrgs);
    setTeamsList(reversedOrgs);
    setIsDropDown(false);
    setIsLoading(false);
  };

  const setDeleted = () => {
    setSearchInput("");
    SetTeamType(Loc.currentLang.menu.hidden);
    const filteredOrgs =
      user?.orgs?.filter((x) => x?.status === "Deleted") || [];
    let reversedOrgs = filteredOrgs?.reverse();
    reversedOrgs = reversedOrgs?.filter((x) => x?.type !== "Channel");
    reversedOrgs = reversedOrgs
      .filter((org) => org.title)
      .sort((a, b) => a.title.localeCompare(b.title));
    setTeamsData(reversedOrgs);
    setTeamsList(reversedOrgs);
    setIsDropDown(false);
    setIsLoading(false);
  };

  const setPerformanceGroup = () => {
    setSearchInput("");
    SetTeamType(Loc.currentLang.menu.musicGroup);
    const filteredOrgs =
      user?.orgs?.filter(
        (x) =>
          x?.type === "PlayerOrg" &&
          x?.subType === "MusicGroup" &&
          x?.status !== "Deleted",
      ) || [];
    let reversedOrgs = filteredOrgs?.reverse();
    reversedOrgs = reversedOrgs?.filter((x) => x?.type !== "Channel");
    reversedOrgs = reversedOrgs
      .filter((org) => org.title)
      .sort((a, b) => a.title.localeCompare(b.title));
    setTeamsData(reversedOrgs);
    setTeamsList(reversedOrgs);
    setIsDropDown(false);
    setIsLoading(false);
  };

  const setFollowers = () => {
    setSearchInput("");
    SetTeamType(Loc.currentLang.menu.followings);
    followersdatalist = followersdatalist
      .filter((org) => org.title)
      .sort((a, b) => a.title.localeCompare(b.title));
    setTeamsData(followersdatalist);
    setTeamsList(followersdatalist);
    setIsDropDown(false);
    setIsLoading(false);
  };

  const GetTeams = () => {
    setSearchInput("");
    let filteredOrgs = user?.orgs?.filter(
      (x) => x?.type !== "Person" && x?.type !== "Channel",
    );
    // Reverse the order of filtered organizations
    const reversedFilteredOrgs = filteredOrgs?.reverse();
    let combinedData = [...reversedFilteredOrgs, ...(followersdatalist || [])];
    combinedData = _.uniqBy(combinedData, "id");
    combinedData = combinedData
      .filter((org) => org.title)
      .sort((a, b) => a.title.localeCompare(b.title));
    setTeamsData(combinedData);
    setTeamsList(combinedData);
    //followersList();
    setAll();
    setIsLoading(false);
  };

  //Search Teams filter
  const handleSearch = (item, type) => {
    setSearchInput(item);
    let filteringResult = teamsList;
    if (
      teamType == Loc.currentLang.menu.all ||
      type === Loc.currentLang.menu.all
    ) {
      setSearchedValue(item);
      if (item) {
        setTeamsData(
          teamsList?.filter(
            (x: any) =>
              (x?.data !== undefined &&
                x?.data
                  ?.toLocaleLowerCase()
                  .includes(item.toLocaleLowerCase())) ||
              (x?.title !== undefined &&
                x?.title
                  ?.toLocaleLowerCase()
                  .includes(item.toLocaleLowerCase())),
          ),
        );
      } else {
        setTeamsData(teamsList);
      }
    } else {
      setSearchedValue(item);
      if (item) {
        if (type == Loc.currentLang.menu.filterTeams)
          filteringResult =
            user?.orgs?.filter(
              (x) =>
                (x.type === "PlayerOrg" || x.type === "Team") &&
                x?.subType === undefined,
            ) || [];
        else if (type == Loc.currentLang.menu.clubs)
          filteringResult =
            user?.orgs?.filter(
              (x) => x.subType === "Club" || x.subType === "Term",
            ) || [];
        else if (type == Loc.currentLang.menu.eliteClubs)
          filteringResult = user?.orgs?.filter((x) => x?.type === "Club") || [];
        else if (type == Loc.currentLang.menu.schools)
          filteringResult =
            user?.orgs?.filter(
              (x) =>
                x.type === "School" ||
                x.subType === "Alumni" ||
                x.type === "SchoolYear",
            ) || [];
        else if (type == Loc.currentLang.menu.groups)
          filteringResult =
            user?.orgs?.filter(
              (x) => x.type === "Group" && x?.subType === undefined,
            ) || [];
        else if (type == Loc.currentLang.menu.classes)
          filteringResult =
            user?.orgs?.filter(
              (x) => x?.type === "PlayerOrg" && x?.subType === "Class",
            ) || [];
        else if (type == Loc.currentLang.menu.musicGroup)
          filteringResult =
            user?.orgs?.filter(
              (x) => x?.type === "PlayerOrg" && x?.subType === "MusicGroup",
            ) || [];
        else if (type == Loc.currentLang.menu.community)
          filteringResult =
            user?.orgs?.filter((x) => x.type === "Community") || [];
        else if (type == Loc.currentLang.menu.gradClass)
          filteringResult =
            user?.orgs?.filter(
              (x) => x?.type === "PlayerOrg" && x?.subType === "GradClass",
            ) || [];
        else if (type == Loc.currentLang.menu.neighborHood)
          filteringResult =
            user?.orgs?.filter((x) => x.type === "Neighborhood") || [];
        else {
          filteringResult =
            user?.orgs?.filter((x) => x.type === "Organization") || [];
        }
        setTeamsData(
          filteringResult?.filter(
            (x: any) =>
              (x?.data !== undefined &&
                x?.data
                  ?.toLocaleLowerCase()
                  .includes(item.toLocaleLowerCase())) ||
              (x?.title !== undefined &&
                x?.title
                  ?.toLocaleLowerCase()
                  .includes(item.toLocaleLowerCase())),
          ),
        );
      } else {
        setTeamsData(filteringResult);
      }
    }
  };

  //Filter Array
  const MenuFilter = [
    ...(user?.orgs?.length > 0 || followersdatalist?.length > 0
      ? [{ id: 0, name: Loc.currentLang.menu.all, flag: data, fn: setAll }]
      : []),
    ...(followersdatalist?.length > 0
      ? [
          {
            id: 1,
            name: Loc.currentLang.menu.followings,
            flag: data,
            fn: setFollowers,
          },
        ]
      : []),
    ...(user?.orgs?.filter(
      (x) =>
        (x.type === "PlayerOrg" || x.type === "Team") &&
        x?.status !== "Deleted" &&
        x?.subType == undefined,
    )?.length > 0
      ? [
          {
            id: 2,
            name: Loc.currentLang.menu.filterTeams,
            flag: data,
            fn: setMyTeams,
          },
        ]
      : []),
    ...(user?.orgs?.filter(
      (x) =>
        (x.type === "LeagueOwner" ||
          x.type === "LeagueSeason" ||
          x.type === "LeagueGroup") &&
        x?.status !== "Deleted" &&
        x?.subType === undefined,
    )?.length > 0
      ? [
          {
            id: 3,
            name: "Leagues",
            flag: data,
            fn: setLeagues,
          },
        ]
      : []),
    ...(user?.orgs?.some(
      (x) =>
        (x.subType === "Club" || x.subType === "Term") &&
        x?.status !== "Deleted",
    )
      ? [{ id: 4, name: Loc.currentLang.menu.clubs, flag: data, fn: setClub }]
      : []),
    ...(user?.orgs?.filter((x) => x?.type === "Club" && x?.status !== "Deleted")
      ?.length > 0
      ? [
          {
            id: 5,
            name: Loc.currentLang.menu.eliteClubs,
            flag: data,
            fn: setElite,
          },
        ]
      : []),
    ...(user?.orgs?.filter(
      (x) =>
        (x.type === "School" ||
          x.subType === "Alumni" ||
          x.type === "SchoolYear") &&
        x?.status !== "Deleted",
    )?.length > 0
      ? [
          {
            id: 6,
            name: Loc.currentLang.menu.schools,
            flag: data,
            fn: setSchools,
          },
        ]
      : []),
    ...(user?.orgs?.filter(
      (x) =>
        x.type === "Group" &&
        (x?.subType === undefined || x?.subType === "Department") &&
        x?.status !== "Deleted",
    )?.length > 0
      ? [{ id: 7, name: Loc.currentLang.menu.groups, flag: data, fn: setGroup }]
      : []),
    ...(user?.orgs?.filter(
      (x) =>
        x?.type === "PlayerOrg" &&
        x?.subType === "Class" &&
        x?.status !== "Deleted",
    )?.length > 0
      ? [
          {
            id: 8,
            name: Loc.currentLang.menu.classes,
            flag: data,
            fn: setClass,
          },
        ]
      : []),
    ...(user?.orgs?.filter(
      (x) =>
        x?.type === "PlayerOrg" &&
        x?.subType === "MusicGroup" &&
        x?.status !== "Deleted",
    )?.length > 0
      ? [
          {
            id: 9,
            name: Loc.currentLang.menu.musicGroup,
            flag: data,
            fn: setPerformanceGroup,
          },
        ]
      : []),
    ...(user?.orgs?.filter(
      (x) => x.type === "Community" && x?.status !== "Deleted",
    )?.length > 0
      ? [
          {
            id: 10,
            name: Loc.currentLang.menu.community,
            flag: data,
            fn: setCommunity,
          },
        ]
      : []),
    ...(user?.orgs?.filter(
      (x) =>
        x?.type === "PlayerOrg" &&
        x?.subType === "GradClass" &&
        x?.status !== "Deleted",
    )?.length > 0
      ? [
          {
            id: 11,
            name: Loc.currentLang.menu.gradClass,
            flag: data,
            fn: setGradClass,
          },
        ]
      : []),
    ...(user?.orgs?.filter(
      (x) => x.type === "Neighborhood" && x?.status !== "Deleted",
    )?.length > 0
      ? [
          {
            id: 12,
            name: Loc.currentLang.menu.neighborHood,
            flag: data,
            fn: setNeighbors,
          },
        ]
      : []),
    ...(user?.orgs?.filter(
      (x) => x.type === "Organization" && x?.status !== "Deleted",
    )?.length > 0
      ? [{ id: 13, name: Loc.currentLang.menu.orgs, flag: data, fn: setOrgs }]
      : []),
    ...(user?.orgs?.filter(
      (x) => x?.status === "Deleted" && x?.type !== "Channel",
    )?.length > 0
      ? [
          {
            id: 14,
            name: Loc.currentLang.menu.hidden,
            flag: data,
            fn: setDeleted,
          },
        ]
      : []),
  ];

  //First Render useeffect for get all the teams
  useEffect(() => {
    GetTeams();
  }, [user?.orgs]);

  //Outside Click Close Function
  const menuRefs = React.useRef(null);

  useOutsideAlerter(menuRefs);
  function useOutsideAlerter(ref) {
    React.useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setIsDropDown(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  return (
    <>
      <Box bgColor="#fff" shadow="1" borderRadius={5}>
        <VStack px={3} pt={2}>
          <HStack
            alignItems={"center"}
            space={3}
            flex={1}
            justifyContent={"space-between"}
          >
            {!isMobile && (
              <Text
                fontSize={"20px"}
                fontWeight={"bold"}
                width={isMobile ? "25%" : "40%"}
                text-overflow={"ellipsis"}
                numberOfLines={1}
              >
                {Loc.currentLang.menu.hello},
                <Text
                  color={"AVColor.primary"}
                  width={"100px"}
                  text-overflow={"ellipsis"}
                  fontSize={"17px"}
                  numberOfLines={1}
                >
                  {userName}!
                </Text>
              </Text>
            )}

            <HStack
              alignItems={"center"}
              justifyContent={isMobile ? "flex-start" : "flex-end"}
              space={2}
              width={isMobile ? "100%" : "auto"}
            >
              {!isMobile && (
                <Text fontSize={[12, 14]} color="AVColor.textLite">
                  {Moment().format("MMMM D, Y")}
                </Text>
              )}

              {/*Search*/}
              <Input
                borderWidth={0}
                width={isMobile ? "97%" : "251px"}
                value={searchInput}
                placeholder={Loc.currentLang.menu.searchMyNetwork}
                variant="AVSearchInput"
                placeholderTextColor="AVColor.textLite"
                backgroundColor={"#F5F5F5"}
                borderRadius={"22px"}
                fontSize={"16px"}
                InputLeftElement={
                  <SearchIcon
                    ml="2"
                    size="24px"
                    color="#000"
                    left={"10px"}
                    p={"7px"}
                  />
                }
                InputRightElement={
                  searchInput ? (
                    <IconButton
                      icon={<CloseIcon size="xs" />}
                      size="sm"
                      variant="AVSearchInput"
                      onPress={() => {
                        setSearchInput("");
                        handleSearch("", teamType);
                      }}
                      _hover={{ bg: "transparent" }}
                    />
                  ) : undefined
                }
                onChangeText={(e) => handleSearch(e, teamType)}
              />
            </HStack>
          </HStack>

          {/*TeamFilter*/}
          <div className="custom-scrollbar">
            <HStack width={"100%"} space={5}>
              <VStack width={isMobile ? "100%" : ""}>
                <HStack
                  marginY={"24px"}
                  backgroundColor={"rgba(0,0,0,0.05)"}
                  borderRadius={"18px"}
                  width={isMobile ? "100%" : "auto"}
                  overflowX={isMobile ? "auto" : undefined}
                  height={"36px"}
                >
                  {MenuFilter?.slice(0, 6)?.map((item, index) => (
                    <Filter
                      key={item.id}
                      Type={teamType}
                      SetType={item?.fn}
                      Name={item?.name}
                    />
                  ))}
                  {MenuFilter?.slice(6)?.length > 0 && (
                    <Pressable
                      marginLeft={"-5px"}
                      marginTop={"4px"}
                      onPress={() => setIsDropDown(!isDropDown)}
                    >
                      <Image source={Dropdown} alt="Actavivo" size="30px" />
                    </Pressable>
                  )}
                </HStack>

                {isDropDown && (
                  <VStack
                    ref={menuRefs}
                    width={"128px"}
                    height="auto"
                    shadow={2}
                    background={"#FFFFFF"}
                    position={"absolute"}
                    top={"66px"}
                    right={0}
                    zIndex={999}
                    borderRadius={"6px"}
                  >
                    {MenuFilter?.slice(6, MenuFilter?.length)?.map(
                      (item, index) => (
                        <>
                          <Pressable
                            ref={menuRefs}
                            key={item.id + index}
                            onPress={item.fn}
                            width={"100%"}
                            height={"36px"}
                            alignItems={"flex-start"}
                            paddingX={"10px"}
                            _hover={{
                              backgroundColor: "gray.100",
                            }}
                            justifyContent={"center"}
                          >
                            <Text fontSize={"14px"} fontFamily={"Roboto"}>
                              {item.name}
                            </Text>
                          </Pressable>
                          <Divider />
                        </>
                      ),
                    )}
                  </VStack>
                )}
              </VStack>
            </HStack>
          </div>
        </VStack>
      </Box>

      {/*RenderCard*/}
      <VStack my={3} zIndex={isDropDown ? -3 : ""}>
        <Text fontSize={"24px"} color={"AVColor.primary"}>
          {Loc.currentLang.menu.myNetwork}
        </Text>

        <HStack
          backgroundColor={"AVColor.white"}
          space={1}
          flexWrap={"wrap"}
          mt={2}
          mb={isMobile ? "30px" : ""}
          height={"auto"}
          borderRadius={5}
          justifyContent={"center"}
          p={2}
          width={"100%"}
        >
          {isLoading && (
            <HStack
              width={"100%"}
              flexWrap={"wrap"}
              justifyContent={"space-around"}
            >
              {[...Array(9)].map((i, index) => (
                <Box key={index} width={"1/3"}>
                  <OrgCardLoader />
                </Box>
              ))}
            </HStack>
          )}

          {data?.length !== 0 && (
            <RenderEvents data={data} allEventData={user?.orgs} />
          )}

          {data?.length === 0 && (
            <VStack>
              <HStack padding={"10px"} alignItems={"center"}>
                <Text>{Loc.currentLang.menu.noNetworkFound}</Text>
              </HStack>
            </VStack>
          )}
        </HStack>
      </VStack>
    </>
  );
};

export default React.memo(MyTeams);
